module.exports = __webpack_public_path__ + "media/payment.5edbe8fe.webm";